import React, { useState } from "react";
import "../css/ModalAlertBox.css";
const ModalAlertBox = (params) => {
  const showHideClassName = params.show
    ? "modal display-block"
    : "modal display-none";
  return (
    <div className={showHideClassName}>
      <img src={params.imgUrl}></img>
      <h2>{params.title}</h2>
      <p>{params.text}</p>
      <h4>{params.btnTxt}</h4>
    </div>
  );
};
export default ModalAlertBox;
